const cancellation = {
  headerTitle: 'طلب إلغاء التأمين و إسترداد المبلغ',
  cancelReason: 'سبب الإلغاء',
  ibanNumber: 'رقم الآيبان',
  addNew: 'إضافة جديد',
  ibanPlaceholder: 'SA03 0000 0000 0000 0000 0000',
  confirmMobile: 'تأكيد رقم الجوال',
  confirmEmail: 'تأكيد البريد الإلكتروني',
  documentsRequired: 'الوثائق المطلوبة للإلغاء',
  chooseFile: 'اختر ملف',
  downloadTemplate: 'تحميل النموذج',
  cancel: 'إلغاء',
  submit: 'إرسال',
  mobilePlaceholder: '05XXXXXXXX',
  emailPlaceholder: 'user@example.com',
  // Validation Messages
  validation: {
    reasonRequired: 'سبب الإلغاء مطلوب',
    ibanRequired: 'رقم الآيبان مطلوب',
    ibanInvalid: 'صيغة الآيبان غير صالحة. يجب أن يبدأ بـ SA متبوع بـ 24 حرف',
    mobileRequired: 'رقم الجوال المؤكد مطلوب',
    mobileInvalid:
      'رقم الجوال يجب أن يبدأ بـ 05 متبوع بـ 8 أرقام (أرقام إنجليزية فقط)',
    emailRequired: 'البريد الإلكتروني المؤكد مطلوب',
    emailInvalid: 'صيغة البريد الإلكتروني غير صالحة',
    emailMax: 'يجب ألا يتجاوز عنوان البريد الإلكتروني 100 حرف',
    documentsMin: 'يجب تحميل مستندين على الأقل.',
    documentsMax: 'الحد الأقصى 5 مستندات مسموح.',
    fileRequired: 'المستند مطلوب',
    fileSize: 'حجم الملف يتجاوز الحد الأقصى 5 ميجابايت',
    fileType: 'نوع الملف غير صالح. الأنواع المسموح بها: PDF, JPG, JPEG, PNG',
  },
  fileDescription: 'الحجم الأقصى: 5MB. الصيغ: PDF, JPG, PNG.',
  // Upload Progress
  uploadStarting: 'بدء الرفع...',
  uploading: 'جاري رفع المستندات...',
  uploadComplete: 'تم الرفع بنجاح',
  cancelUpload: 'إلغاء الرفع',
}

export default cancellation
